import React, { useRef, useEffect, useCallback } from "react";
import { STLLoader } from "three/addons/loaders/STLLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import { connect } from "react-redux";
import action from "../../../store/action";

import "./index.less";
import { mergeVertices } from "three/examples/jsm/utils/BufferGeometryUtils.js";

/**
 * @description create tooth function. In order to batch creation tooth
 * @param props The parameter passed by the attribute within the tag
 * */
function ToothModel(props) {
  const {
    itemId,
    toothGumType,
    toothNumber,
    toothIndex,
    model,
    opacity,
    setCurrentClickItemId,
    setCurrentClickInitItemRef,
    currentClickItemId,
    dragging,
    setCurrentClickPontic,
  } = props;

  const ref = useRef();

  useEffect(() => {
    if (toothNumber === currentClickItemId) {
      setCurrentClickInitItemRef(ref.current);
    }
  }, [currentClickItemId]);

  const clickHandler = useCallback((e) => {
    if (dragging) {
      return;
    }

    if (e.eventObject.material.opacity === 1 && e.eventObject.visible) {
      e.stopPropagation();

      setCurrentClickItemId(toothNumber);

      setCurrentClickPontic(null);
    }

    // ToothDataPro prevent a bubble
  }, []);

  return (
    <mesh
      {...props}
      ref={ref}
      geometry={model}
      // renderOrder={initTooth ? 1 : 0}
      // matrix={toothMatrix}
      // matrixAutoUpdate={false}
      onClick={(event) => clickHandler(event)}
      name={itemId}
    >
      <meshPhysicalMaterial
        attach="material"
        color={currentClickItemId == toothNumber ? "orange" : "#FFFFFF"}
        opacity={opacity}
        transparent={true}
        depthWrite={opacity > 0.5 ? true : false}
        depthTest={true}
        clearcoat={0.5}
        clearcoatRoughness={0.3}
        roughness={0.4}
        metalness={0}
        reflectivity={0.2}
        emissive={"#FFFFFF"}
        emissiveIntensity={0.05}
        flatShading={false}
      />
    </mesh>
  );
}

const mapStateToProps = (state) => ({
  sliderVal: state.webViewer.sliderVal,
  view: state.webViewer.view,
  currentClickItemId: state.webViewer.currentClickItemId,
  dragging: state.webViewer.dragging,
  toothData: state.webViewer.toothData,
  keyframeNumber: state.webViewer.keyframeNumber,
  attachmentCheckboxValue: state.webViewer.attachmentCheckboxValue,
  panelData: state.webViewer.panelData,
  cameraControlRef: state.webViewer.cameraControlRef,
  gridCheckboxValue: state.webViewer.gridCheckboxValue,
  isMobile: state.webViewer.isMobile,
  editMode: state.webViewer.editMode,
});

const mapDispatchToProps = (dispatch) => ({
  setView: (val) => dispatch(action.setView(val)),
  setCurrentClickItemId: (val) => dispatch(action.setCurrentClickItemId(val)),
  setCurrentClickPontic: (val) => dispatch(action.setCurrentClickPontic(val)),
  setCurrentClickItemRef: (val) => dispatch(action.setCurrentClickItemRef(val)),
  setCurrentClickInitItemRef: (val) =>
    dispatch(action.setCurrentClickInitItemRef(val)),
  setDragging: (val) => dispatch(action.setDragging(val)),
  setToothData: (val) => dispatch(action.setToothData(val)),
  setPivotData: (val) => dispatch(action.setPivotData(val)),
  setPanelData: (val) => dispatch(action.setPanelData(val)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ToothModel);
